const shipmentContainerGroupTerms = {
  '22GP': '20′ Standard',
  '42GP': '40′ Standard',
  '45GP': '40′ High Cube',
  L5GP: '40′ Reefer Standard',
  '22RT': '40′ Reefer Standard',
  '42RC': '40′ Reefer Standard',
} as const

const bookingContainerGroupTerms = {
  '22G0': '20′ Standard',
  '42G0': '40′ Standard',
  '45G0': '40′ High Cube',
} as const

export const containerTypeGroupTerms = {
  ...shipmentContainerGroupTerms,
  ...bookingContainerGroupTerms,
} as const

export type ContainerType = keyof typeof containerTypeGroupTerms

export const isValidContainerType = (type: string): type is ContainerType =>
  Object.keys(containerTypeGroupTerms).includes(type)

export const getContainerGroupTerm = (type?: string): string => {
  if (type && isValidContainerType(type)) {
    return containerTypeGroupTerms[type]
  }
  return type || '-'
}
